import React, { FC } from 'react';

import ActionRow from './ActionRow';
import { ActionType } from 'src/actions/rules/actions';
import {
  StyledInformationIcon,
  StyledTooltip,
  StyledTypeDescription,
} from 'src/presentation/components/pages/rules/shared/StyledComponents';

type CloseConversationActionProps = {
  onDelete: Function;
};

const CloseConversationAction: FC<CloseConversationActionProps> = ({ onDelete }) => {
  return (
    <ActionRow type={ActionType.CloseConversation} onDelete={onDelete}>
      <StyledTypeDescription>Close Conversation</StyledTypeDescription>
      <div>
        <StyledTooltip message="Conversations with ongoing phone calls cannot be closed">
          <StyledInformationIcon />
        </StyledTooltip>
      </div>
    </ActionRow>
  );
};

export default CloseConversationAction;
